export default __webpack_public_path__ + "static/media/logo.8fdc4f3a.svg";